import React, { useLayoutEffect } from 'react'
import Helmet from 'react-helmet'
import favicon from '../images/favicon.ico'
import Layout from '../Layout/Layout'
import SEO from '../components/seo'



const RedirectTemplate = ({ pageContext }) => {
  const { isExternal, route, redirect, title } = pageContext

  useLayoutEffect(() => {
    if (!window || !redirect) {
      return
    }

    if (isExternal) {
      window.location.href = `https://${redirect}`
    } else {
      window.location.pathname = redirect
    }
  }, [isExternal, redirect])

  return (
    <Layout>
      <SEO
        title={title}
        url={`https://www.mailgun.com/${route}`}
        type="article"
      />
      <Helmet defer={false}>
        <title>{title}</title>
        <meta name="description" content="Redirect to new location" />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href={route} />
        <link rel="icon" href={favicon} />
      </Helmet>
    </Layout>
  )
}

export default RedirectTemplate
